export interface BingoCard {
  title: string;
  header: string[];
  rows: string[][];
  imageId?: string;
}

export interface BingoTheme {
  id: string;
  name: string;
  primary: string;
  secondary: string;
  accent: string;
}

export const BINGO_THEMES: BingoTheme[] = [
  { id: 'default', name: 'Clássico', primary: '#000000', secondary: '#ffffff', accent: '#000000' },
  { id: 'logo-purple', name: 'Roxo Principal', primary: '#3a0ca3', secondary: '#f5f3ff', accent: '#4361ee' },
  { id: 'logo-red', name: 'Vermelho Vibrante', primary: '#ff4d4d', secondary: '#fff5f5', accent: '#fb5607' },
  { id: 'logo-green', name: 'Verde Mar', primary: '#06d6a0', secondary: '#f0fff4', accent: '#2ec4b6' },
  { id: 'logo-yellow', name: 'Amarelo Ouro', primary: '#ffbe0b', secondary: '#fffbeb', accent: '#ff9f1c' },
  { id: 'logo-blue', name: 'Azul Elétrico', primary: '#3a86ff', secondary: '#f0f9ff', accent: '#4361ee' },
];

export interface ImageData {
  id: string;
  data: string;
}

export interface BingoResponse {
  cards: BingoCard[];
  images: ImageData[];
}
